module.exports = function() {
	var user = {};

	user.settings = {
		loginUrl : require('/app/js/objs/config').apiBaseUrl + '/v1/swornpro/users/',
	};
	user.loginState = false;
	user.data = {};


	user.init = function() {
		// ist der user schon eingeloggt? Ohne Login-Token (alte Version) einmal neu einloggen.
		if (window.store.get('user') && window.store.get('user').id && window.store.get('apiToken')) {
			user.data = window.store.get('user');
			user.loginState = true;
		} else {
			$.ajax({
				'async' : false,
				'type' : 'GET',
				'xhrFields': { withCredentials: true },
				'crossDomain': true,
				'dataType' : 'json',
				'url' : this.settings.loginUrl + 'loginStatus',
				'success' : function(data) {
					if (data.loginStatus && data.loginStatus == 1) {
						user.data = data.loginUser;
						user.loginState = true;
					} else {
						$('#errorMessage').html('<p>Benutzername oder Passwort falsch!</p>');
					}
				}
			});
		}
	};

	user.isLoggedIn = function() {
		return this.loginState;
	}

	user.login = function(username,password) {
		$.ajax(this.settings.loginUrl + 'auth', {
			method: 'POST',
			data: {username: username, password: password, issue_token: 1},
			crossDomain: true,
			success: function(data) {
				console.log(data);
				if (data.error) {
					$('#errorMessage').html('<p>Benutzername oder Passwort falsch!</p>');
					return false;
				}
				if (data.loginStatus && data.loginStatus == 1) {
					window.store.set('user', data.loginUser);
					// Login-Token fuer alle weiteren API-Aufrufe (30 Tage gueltig)
					window.store.set('apiToken', data.token);
					//window.location.hash = '#home';
					window.location.reload();

				}

			}
		});

	};

	user.logout = function() {
		// Token in der API widerrufen, dann lokal abmelden
		var token = window.store.get('apiToken');
		$.ajax(this.settings.loginUrl + 'logout', {
			'headers': token ? {'Authorization': 'Bearer ' + token} : {},
			'complete': function() {
				window.store.remove('user');
				window.store.remove('apiToken');
				window.location.reload();
			}
		});
	}

	/**
	 * Token abgelaufen oder widerrufen (API antwortet 401): lokal abmelden und Login zeigen.
	 * Offene Stundenzettel bleiben im Browser gespeichert und werden nach dem Login wieder hochgeladen.
	 */
	user.expired = function() {
		if (user.expiredHandled) {
			return;
		}
		user.expiredHandled = true;
		window.store.remove('user');
		window.store.remove('apiToken');
		window.location.reload();
	}


	user.init();
	return user;
}
